import {
    allFetch
} from "../Domain";

/**
 * @description 檔案
 */
export const Files = (() => {

    /**
     * @description 檔案移動
     */
    const UploadFile = async function (formData) {
        return await allFetch('Files/UploadFile', formData);
    }

    /**
     * @description 檔案查詢
     */
    const SearchFile = async function (obj = {
        file_id: '',
        belong: '',
        type: '',
        id: '',
        cre_time_start: '',
        cre_time_end: '',
        blob: '',
        isvalid: ''
    }) {
        return await allFetch('Files/SearchFile', obj);
    }

    /**
     * @description 檔案移動
     */
    const MoveFile = async function (obj = {
        file_id: '',
        belong: '',
        type: '',
        id: ''
    }) {
        return await allFetch('Files/MoveFile', obj);
    }

    /**
     * @description 檔案刪除
     */
    const DeleteFile = async function (obj = {
        file_id: ''
    }) {
        return await allFetch('Files/DeleteFile', obj);
    }

    return {
        SearchFile,
        MoveFile,
        UploadFile,
        DeleteFile
    }
})();